import React, { useState } from 'react';
const testimonials = [{
  initials: 'MG',
  name: 'Martín G.',
  location: 'Buenos Aires · Desarrollador',
  quote: 'En la primera semana apliqué el Protocolo de Mañana y el dolor de cuello que tenía desde hace dos años bajó un 70%. Antes llegaba a casa destruido. Ahora llego cansado como cualquier persona normal, no con el cuello duro como tabla.'
}, {
  initials: 'VR',
  name: 'Valeria R.',
  location: 'Córdoba · Contadora',
  quote: 'Los micro-movimientos del Método 30-30 me cambiaron la jornada laboral. Antes a las 5 de la tarde ya no podía más con los hombros. Ahora termino el día con una tensión completamente manejable. Y lo hago sin salir de mi escritorio.'
}, {
  initials: 'SR',
  name: 'Santiago R.',
  location: 'Rosario · Diseñador gráfico',
  quote: 'El Tomo 3 me hizo darme cuenta de que trabajaba con el monitor 15 centímetros más bajo de lo que debería. Cambié eso en 5 minutos con libros y el dolor de cuello bajó en 48 horas. En 48 horas. Sin pastillas, sin masajes, sin nada.'
}];
const painPoints = ['Llegás al trabajo y antes del mediodía ya sentís que el cuello empieza a agarrotarse aunque hayas dormido bien', 'Compraste una silla "ergonómica" pero el dolor sigue igual porque nadie te explicó que la silla sin setup correcto no sirve de nada', 'Hacés algunos estiramientos de YouTube que alivian 20 minutos y después el dolor vuelve exactamente donde estaba', 'Hay semanas donde el dolor de espalda o cuello es tan intenso que afecta tu concentración y tu rendimiento laboral', 'Sabés que tenés que hacer algo pero entre el trabajo, la casa y todo lo demás nunca encontrás el momento ni sabés por dónde empezar', 'Al final del año trabajaste mucho pero tu cuerpo está pagando un precio que nadie te dijo que ibas a pagar', 'Tu cuello, tu espalda y tus hombros están acumulando una tensión crónica que si no se atiende hoy puede convertirse en algo más serio en 3 o 5 años'];
export function ProblemSection() {
  const [showAll, setShowAll] = useState(false);
  const visiblePoints = showAll ? painPoints : painPoints.slice(0, 3);
  return <section className="py-8 md:py-24 bg-[#F1F4F8]" data-id="element-191">
      <div className="max-w-6xl mx-auto px-4" data-id="element-192">
        {/* Section eyebrow */}
        <div className="text-center mb-5 md:mb-14" data-id="element-193">
          <div className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#2D9596] font-bold uppercase mb-2 sm:mb-3" data-id="element-194">
            ⭐ Lo que dicen los que ya lo tienen
          </div>
        </div>

        {/* Testimonials — horizontal scroll on mobile */}
        <div className="md:hidden mb-8 -mx-4 px-4 overflow-x-auto snap-x snap-mandatory scroll-pl-4 scrollbar-hide" data-id="element-195">
          <div className="flex gap-3 pb-2" style={{
          width: 'max-content'
        }} data-id="element-196">
            {testimonials.map((t, i) => <div key={i} className="snap-start bg-white border border-[#D5DCE5] rounded-2xl p-4 shadow-sm w-[280px] shrink-0" data-id="element-197">
                <div className="flex items-center gap-2.5 mb-2.5" data-id="element-198">
                  <div className="w-9 h-9 rounded-full bg-[#E8EDF3] text-[#1E3A5F] flex items-center justify-center font-bold text-xs border border-[#D5DCE5]" data-id="element-199">
                    {t.initials}
                  </div>
                  <div data-id="element-200">
                    <div className="text-[#2D9596] text-[10px] tracking-wider mb-0.5" data-id="element-201">
                      ★★★★★
                    </div>
                    <div className="text-xs text-[#1A2433] font-medium leading-tight" data-id="element-202">
                      {t.name}
                    </div>
                  </div>
                </div>
                <p className="text-[#4A5568] italic leading-snug text-xs" data-id="element-203">
                  "{t.quote}"
                </p>
                <div className="mt-2.5 text-[9px] text-[#2D9596] font-medium tracking-wider uppercase" data-id="element-204">
                  {t.location}
                </div>
              </div>)}
          </div>
          <div className="text-center text-[10px] text-[#4A5568] mt-2 italic" data-id="element-205">
            ← Deslizá para ver más →
          </div>
        </div>

        {/* Desktop testimonials grid */}
        <div className="hidden md:grid sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-5 md:gap-6 mb-12 md:mb-28" data-id="element-206">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#D5DCE5] rounded-2xl p-4 sm:p-6 hover:border-[#2D9596] hover:-translate-y-0.5 transition-all shadow-sm" data-id="element-207">
              <div className="flex items-center gap-3 mb-3 sm:mb-4" data-id="element-208">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#E8EDF3] text-[#1E3A5F] flex items-center justify-center font-bold text-sm border border-[#D5DCE5]" data-id="element-209">
                  {t.initials}
                </div>
                <div data-id="element-210">
                  <div className="text-[#2D9596] text-xs tracking-wider mb-0.5" data-id="element-211">
                    ★★★★★
                  </div>
                  <div className="text-sm text-[#1A2433] font-medium" data-id="element-212">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-[#4A5568] italic leading-relaxed text-xs sm:text-sm md:text-base" data-id="element-213">
                "{t.quote}"
              </p>
              <div className="mt-3 sm:mt-4 text-[10px] sm:text-xs text-[#2D9596] font-medium tracking-wider uppercase" data-id="element-214">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-5 sm:mb-12" data-id="element-215">
          <h2 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] mb-3 sm:mb-6 leading-tight" data-id="element-216">
            ¿Cuántos lunes más vas a llegar al trabajo{' '}
            <span className="italic" data-id="element-217">como si no hubieras descansado</span>?
          </h2>
          <p className="hidden sm:block text-sm sm:text-base md:text-lg text-[#4A5568] leading-relaxed" data-id="element-218">
            Querés estar bien. Tenés el trabajo que elegiste. Pero nadie te dijo
            que ibas a pasar los domingos con el cuerpo anticipando el lunes,
            las tardes con un dolor sordo en los hombros que no se va nunca y
            los viernes contando cuántos ibuprofenos tomaste esa semana por algo
            que "viene con el trabajo".
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-[#1E3A5F] italic font-medium mt-3 sm:mt-6" data-id="element-219">
            No es tu cuerpo el problema. Es la falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white border border-[#D5DCE5] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 shadow-md" data-id="element-220">
          <div className="space-y-2.5 sm:space-y-5" data-id="element-221">
            {visiblePoints.map((point, i) => <div key={i} className="flex items-start gap-2 sm:gap-4 animate-fade-in-up" style={{
            animationDelay: `${i * 60}ms`
          }} data-id="element-222">
                <span className="text-[#1E3A5F] text-sm sm:text-lg mt-0.5 shrink-0" data-id="element-223">
                  ❌
                </span>
                <p className="text-xs sm:text-sm md:text-base text-[#4A5568] leading-snug sm:leading-relaxed" data-id="element-224">
                  {point}
                </p>
              </div>)}
          </div>
          {painPoints.length > 3 && <button onClick={() => setShowAll(!showAll)} className="md:hidden mt-4 w-full py-2.5 rounded-full bg-[#E8EDF3] text-[#1E3A5F] text-xs font-bold uppercase tracking-wider flex items-center justify-center gap-1.5 active:scale-95 transition-transform border border-[#D5DCE5]" aria-expanded={showAll} data-id="element-225">
              {showAll ? 'Ver menos' : `Ver ${painPoints.length - 3} más`}
              <svg className={`w-3 h-3 transition-transform ${showAll ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-226">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-227" />
              </svg>
            </button>}
        </div>

        <div className="text-center mt-6 sm:mt-16" data-id="element-228">
          <h3 className="text-lg sm:text-2xl md:text-4xl text-[#1A2433] leading-tight" data-id="element-229">
            ¿Y si este fuera el último lunes que{' '}
            <span className="italic text-[#1E3A5F]" data-id="element-230">
              llegás con el cuerpo en deuda
            </span>
            ?
          </h3>
        </div>
      </div>
    </section>;
}